
import React from 'react';
import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { formatDate } from '@/lib/utils';
import { Issue, issues } from '@/data/newsletter-issues';
import { ExternalLink } from 'lucide-react';

const NewsletterPastIssues = () => {

  return (
    <section id="past-issues" className="py-20 bg-neutral-light/30">
      <div className="container px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Past Issues</h2>
          <p className="text-lg text-secondary-dark mb-8">
            Explore our previous newsletters for insights on tech recruitment and career trends.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {issues.map((issue, index) => (
            <Card key={index} className="h-full flex flex-col hover:shadow-lg transition-shadow border border-neutral-light overflow-hidden">
              {issue.image && (
                <a href={issue.url} target="_blank" rel="noopener noreferrer" className="w-full h-48 overflow-hidden block">
                  <img 
                    src={issue.image} 
                    alt={issue.title}
                    className="w-full h-full object-cover transition-transform hover:scale-105"
                    loading="lazy"
                    width="400"
                    height="225"
                    onError={(e) => {
                      console.log(`Failed to load image at index ${index}. Using fallback.`);
                      e.currentTarget.src = '/placeholder.svg';
                    }}
                  />
                </a>
              )}
              <CardContent className="pt-6 flex-grow">
                <p className="text-sm text-gray-600 mb-2">{formatDate(new Date(issue.date))}</p>
                <a href={issue.url} target="_blank" rel="noopener noreferrer" className="hover:text-primary">
                  <h3 className="text-xl font-bold mb-4">{issue.title}</h3>
                </a>
              </CardContent>
              <CardFooter className="pt-0 pb-6">
                <a href={issue.url} target="_blank" rel="noopener noreferrer" className="w-full">
                  <Button 
                    className="w-full bg-primary text-white hover:bg-primary-light"
                  >
                    Read edition <ExternalLink className="h-4 w-4 ml-2" />
                  </Button>
                </a>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsletterPastIssues;

